<template>
  <div>
    <!-- Product Spec -->
    <div class="d-flex justify-space-between mb-2">
      <h3>Product Spec</h3>
      <button
        class="btn"
        @click="$router.push('/products/product-info/edit/edit-spec')"
      >
        <v-icon class="mr-2">edit</v-icon>
        <span>前往編輯Spec欄位</span>
      </button>
    </div>
    <div class="mb-5">資訊將顯示於產品頁、產品比較表</div>
    <div>
      <!-- 規格 -->
      <div
        v-for="(item, i) in subcategory.specs"
        :key="item.id"
      >
        <label class="form-item pa-5 d-flex" v-if="!item.is_customized">
          <div class="w-267px">
            <h4>{{ item.title }}</h4>
          </div>
          <div class="w-100 d-flex">
            <div class="flex-grow-1 flex-basis-0">
              <div class="form-input-group d-flex"
                   v-for="(option, oi) in product.specs[i].options"
                   :key="oi"
              >
                <v-textarea
                  v-model="option.title"
                  row-height="7"
                  auto-grow
                  outlined
                  dense
                ></v-textarea>
                <button class="btn square ml-5"
                        v-if="oi === 0"
                        @click="addSpec(product.specs[i].options)">
                  <v-icon>add</v-icon>
                </button>
                <button class="btn square ml-5"
                        v-if="oi === 0"
                        @click="detachOptions(i)">
                  <v-icon>clear</v-icon>
                </button>
                <button class="btn square ml-5"
                        v-if="oi > 0"
                        @click="removeSpec(product.specs[i].options, oi)"
                >
                  <v-icon>delete</v-icon>
                </button>
              </div>
            </div>
          </div>
        </label>
      </div>

      <!-- 備註 -->
      <div class="form-item pa-5 d-flex">
        <div class="w-267px">
          <h4>備註</h4>
        </div>
        <div class="w-100 d-flex">
          <div class="flex-grow-1 flex-basis-0">
            <editor
              v-model="product.remark"
              :plugins="'link lists'"
              :toolbar="'link lists'"
            />
          </div>
        </div>
      </div>
    </div>

    <!-- Product Filter -->
    <div class="d-flex justify-space-between mb-2 mt-5">
      <h3>Filter將顯示於Product Category Page</h3>
      <button
        class="btn"
        @click="toProductInfoEditFilterEdit"
      >
        <v-icon class="mr-2">edit</v-icon>
        <span>前往編輯Filter欄位</span>
      </button>
    </div>
    <div class="mb-5"></div>
    <div>
      <!-- 特點 -->
      <div
        v-for="(item, i) in subcategory.specs"
        :key="item.id"
      >
        <label class="form-item pa-5 d-flex" v-if="item.is_customized">
          <div class="w-267px">
            <h4>{{ item.title }}</h4>
          </div>
          <div class="w-100 d-flex">
            <div class="flex-grow-1 flex-basis-0">
              <div class="form-input-group d-flex"
                   v-for="(option, oi) in product.specs[i].options"
                   :key="oi"
              >
                <v-textarea
                  v-model="option.title"
                  row-height="7"
                  auto-grow
                  outlined
                  dense
                ></v-textarea>
                <button class="btn square ml-5"
                        v-if="oi === 0"
                        @click="addSpec(product.specs[i].options)">
                  <v-icon>add</v-icon>
                </button>
                <button class="btn square ml-5"
                        v-if="oi === 0"
                        @click="detachOptions(i)">
                  <v-icon>clear</v-icon>
                </button>
                <button class="btn square ml-5"
                        v-if="oi > 0"
                        @click="removeSpec(product.specs[i].options, oi)"
                >
                  <v-icon>delete</v-icon>
                </button>
              </div>
            </div>
          </div>
        </label>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import Editor from '@/components/TinymceEditor.vue';

export default {
  props: {
    product: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {
    Editor,
  },
  computed: {
    ...mapState('subcategory', [
      'subcategory',
    ]),
  },
  methods: {
    ...mapActions('product', [
      'detachFilterOptions',
      'findById',
    ]),
    toProductInfoEditFilterEdit() {
      this.$router.push({
        name: 'ProductInfoEditFilterEdit',
        params: {
          id: this.subcategory.id,
        },
      });
    },
    detachOptions(i) {
      const ids = this.product.specs[i].options.map((o) => o.id).filter((o) => o != null);
      this.detachFilterOptions({
        id: this.product.id,
        ids,
      }).then(() => {
        this.product.specs[i].options = [];
        this.addSpec(this.product.specs[i].options);
      });
    },
    addSpec(target) {
      target.push({
        id: null,
        title: null,
      });
    },
    removeSpec(target, index) {
      target.splice(index, 1);
    },
  },
};
</script>

<style></style>
